
export default class WinnebagoService {
    antiForgeryToken = document.querySelector('input[name="__RequestVerificationToken"]').value;

    getPropertyInfo(pin) {
        return new Promise((resolve, reject) => {
         //   const url = `${window.location.origin}${window.location.pathname}?handler=GetParcelSummaryAjax`;
            const url = window.RootUrl + "getparcelsummary"
            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "RequestVerificationToken": this.antiForgeryToken
                },
                body: new URLSearchParams({ pin: pin })
            })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(`Error: ${response.status} - ${text}`);
                    });
                }
                return response.json();  // Assuming the server returns JSON
            })
            .then(data => resolve(data))
            .catch(error => reject(error.message));
        });
    }
    getSchoolDistrictInfo(geometry) {
        throw new Error("Method must be implemented.");
    }
    findZoningResults(geometry) {
        throw new Error("Method must be implemented.");
    }
}
